import React from 'react';
import { FormikProps } from 'formik';
import { ContactUpdatedFields, UpdateDepositValues } from 'types';
import { ContactInformationProFormView } from './ContactInformationProFormView';
import { Alert, Text } from '@groupelacentrale/contact-storybook';

export const UpdateContactProForm: React.FC<
  FormikProps<UpdateDepositValues> & { emails: string[]; updatedFields: ContactUpdatedFields }
> = ({ emails, ...props }) => {
  if (emails.length === 0) {
    return (
      <Alert type="error">
        <Text size="medium" weight="bold">
          Votre compte ne comporte pas d&apos;adresse email. Veuillez contacter le service professionnel.
        </Text>
      </Alert>
    );
  } else {
    return (
      <div className="update-contact-form">
        {/* @ts-ignore */}
        <ContactInformationProFormView
          handleReturn={() => {}}
          {...props}
          handleSubmit={() => {}}
          showActions={false}
          emails={emails}
        />
      </div>
    );
  }
};
